import React from 'react'
import ReplyItem from './ReplyItem'

const ReplyList = (props) => {
    return (
        <ul>
            {props.replies.map((r, idx) =>
                <ReplyItem
                    key={idx}
                    id={r.TalkbackId}
                    title={r.Title}
                    content={r.Content}
                    author={r.AuthorName}
                />)}
        </ul>
    )
}

export default ReplyList;


// WEBPACK FOOTER //
// ./src/Components/comments/ReplyList.jsx